import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Software, Type, Category } from "app/profile/models/software.model";
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { getSoftwareCategories, getSoftwareTypes } from 'app/profile/store/selectors/software.selector';
import { debounceTime, startWith, map } from 'rxjs/operators';
import { TslOption } from '@tesla/ng-tds';
import { SupplierProfileState } from 'app/profile/store/app.reducer';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
    selector: "app-software-form-dialog",
    templateUrl: "./software-form-dialog.component.html",
    styleUrls: ["./software-form-dialog.component.scss"]
})
export class SoftwareFormDialogComponent implements OnInit {
    softwareCategories$: Observable<Category[]>;
    filteredTypes$: Observable<Type[]>;
    softwareTypes: Type[];
    softwareForm: FormGroup;

    get category() { return this.softwareForm.get('category'); }
    get type() { return this.softwareForm.get('type'); }
    get version() { return this.softwareForm.get('version'); }
    get description() { return this.softwareForm.get('description'); }

    constructor(
        private fb: FormBuilder,
        private translate: I18nService,
        private store: Store<SupplierProfileState>,
        public dialogRef: MatDialogRef<SoftwareFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Software
    ) {
        this.softwareForm = this.fb.group({
            category: ['', Validators.required],
            type: ['', Validators.required],
            version: [''],
            description: ['']
        });

        this.filteredTypes$ = this.type.valueChanges
            .pipe(
                debounceTime(300),
                startWith(' '),
                map(value => this.filterType(value))
            );
    }

    ngOnInit() {
        this.loadResources();

        this.softwareForm.patchValue({
            category: this.data.softwareCategoryId,
            type: this.data.softwareType,
            version: this.data.version,
            description: this.data.formats
        });
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.softwareForm.invalid) {
            return;
        }

        const selectedType = this.softwareTypes.find(s => s.type === this.softwareForm.value.type);
        this.data.softwareCategoryId = this.category.value;
        this.data.softwareTypeId = selectedType !== undefined ? selectedType.id : 0;
        this.data.softwareType = this.type.value;
        this.data.version = this.version.value;
        this.data.formats = this.description.value;
        this.dialogRef.close(this.data);
    }

    onSelectType(option: TslOption): void {
        const softType: Type = option.value;
        this.type.setValue(softType.type);
    }

    private filterType(value: string): Type[] {
        const filterValue = value.toLowerCase();
        if (this.softwareTypes) {
            return this.softwareTypes.filter(
                option => option.type
                    .toLowerCase()
                    .includes(filterValue));
        }
    }

    private loadResources(): void {
        this.softwareCategories$ = this.store.select(getSoftwareCategories);
        this.store.select(getSoftwareTypes)
            .subscribe(res => this.softwareTypes = res);
    }
}
